module.exports = __webpack_public_path__ + "static/img/6-1.9a02343.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/aboutUs/6-1.png
// module id = XZZH
// module chunks = 15